import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=95467d84&scoped=true"
import script from "./phoneLogin.vue?vue&type=script&lang=js"
export * from "./phoneLogin.vue?vue&type=script&lang=js"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&id=95467d84&prod&lang=scss&scoped=true"
import style1 from "./phoneLogin.vue?vue&type=style&index=1&id=95467d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95467d84",
  null
  
)

export default component.exports